import React from "react";
import { motion } from "framer-motion";

const PORTRAIT = "/headshots/amy-wine-pour-refined.png";

const credentials = [
    { num: "15+", label: "Years in hospitality" },
    { num: "100+", label: "Campaigns launched" },
    { num: "$2M+", label: "Revenue activated" },
    { num: "30+", label: "Concepts developed" },
];

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 md:py-32 bg-brand-orange text-brand-cream relative overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8 md:gap-16 items-start">
                    {/* Image */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="col-span-12 md:col-span-4 relative md:pt-8"
                    >
                        <div className="aspect-[4/5] overflow-hidden border-4 border-brand-cream max-w-sm mx-auto md:mx-0">
                            <img
                                src={PORTRAIT}
                                alt="Amy Bates, founder of Eat + Drink Consulting, pouring wine at a restaurant bar — hospitality and food &amp; beverage strategist"
                                loading="lazy"
                                decoding="async"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="absolute -bottom-6 right-0 md:left-0 md:right-auto bg-brand-dark text-brand-cream px-6 py-4 hidden md:block">
                            <span className="font-serif italic text-xl">Amy Bates</span>
                            <span className="block text-[10px] uppercase tracking-[0.25em] text-brand-cream/70 mt-1">
                                Founder &amp; Principal
                            </span>
                        </div>
                    </motion.div>

                    {/* Content */}
                    <div className="col-span-12 md:col-span-8">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7, delay: 0.1 }}
                        >
                            <div className="flex items-center gap-4 mb-6">
                                <span className="h-px w-10 bg-brand-cream" />
                                <span className="text-xs uppercase tracking-[0.3em] font-medium">
                                    Meet the Founder
                                </span>
                            </div>

                            <h2
                                data-testid="about-headline"
                                className="font-serif text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight mb-8"
                            >
                                Strategy that lives <span className="italic">on the floor,</span>{" "}
                                not just on paper.
                            </h2>

                            <div className="space-y-5 text-brand-cream/90 text-lg leading-relaxed font-light max-w-xl">
                                <p>
                                    I'm Amy Bates — a hospitality operator turned consultant. I've
                                    spent my career inside restaurants, bars, and beverage programs
                                    — building events, writing menus, training teams, and obsessing
                                    over the numbers behind every shift.
                                </p>
                                <p>
                                    Eat + Drink Consulting is the playbook I wish every operator
                                    had: practical, revenue-first, and built around what your team
                                    can actually execute on a Tuesday night.
                                </p>
                            </div>

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 mt-12 pt-10 border-t border-brand-cream/30">
                                {credentials.map((c) => (
                                    <div key={c.label} data-testid={`stat-${c.num}`}>
                                        <div className="font-serif text-4xl md:text-5xl mb-1">
                                            {c.num}
                                        </div>
                                        <div className="text-xs uppercase tracking-[0.2em] text-brand-cream/70">
                                            {c.label}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
}
